import { RootState } from '@interfaces/rootState';

export const SharedFiltersSelector = ({ sharedFilters }: RootState) => sharedFilters;
